const type = 'SET_CANCEL_INVOICE_INSTALLMENT_SUBMITTING';

const setCancelInvoiceInstallmentSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setCancelInvoiceInstallmentSubmitting;
